import { Component, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { gridPageRequest, Rfq } from '../../../model/common/common.model';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import _ from 'lodash';
import { Table } from 'jspdf-autotable';
import { RFQService } from '../../../services/rfq.service';
import { MessageService } from 'primeng/api';
import { InventoryService } from '../../../services/inventory.service';

@Component({
  selector: 'app-list-rfq',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './list-rfq.component.html',
  styleUrl: './list-rfq.component.scss'
})

export class ListRFQComponent {
  @ViewChild('dt1') dt1: Table | undefined;

  rfqs: any[] = [];
  rfqList: any;
  paginator: boolean | undefined;
  unitLabel: string = '';

  constructor(
    private router: Router,
    private confirmationService: ConfirmationService,
    private rfqService: RFQService,
    private messageService: MessageService,
    public inventoryService: InventoryService
  ) { }

  loader: boolean = false;
  listRfq: Rfq[] = [];
  selectedRfq: Rfq[] = [];
  searchKey: any;


  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  ngOnInit(): void {
    document.title = 'RFQ List ';
    this.getRFQList();
    this.searchEffect();
    this.inventoryService.getUnitByAppKey('unitNameLabel')
      .subscribe((res: any) => {
        this.unitLabel = res?.data || 'Unit';
      });
  }


  create() {
    this.router.navigate(['/home/createrfq']);
  }

  edit(data?: any): void {
    if (data) {
      this.router.navigate(['/home/createrfq'], { queryParams: { 'rfqId': data }, skipLocationChange: false });
    } else {
      this.router.navigate(['/home/createrfq'], { queryParams: { 'rfqId': this.selectedRfq[0].rfqID }, skipLocationChange: false });
    }
  }

  deleteQuote() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;

        var rfqIds = _.map(this.selectedRfq, 'rfqID');

        this.rfqService.deleteRFQ(rfqIds).subscribe({
          next: (data: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted successfully.' });
            this.loader = false;
            this.selectedRfq = [];
            this.getRFQList();
          },
          error: error => {
            this.loader = false;
            console.log(error);
          }
        })
      },
      reject: () => {
      }
    });

  }


  searchRfq() {
    if (this.searchKey && this.searchKey.trim().length >= 2) {
      this.rfqService.SearchRfq(this.searchKey.trim()).subscribe({
        next: (res: any) => {
          //console.log(res);

          this.rfqList = (Array.isArray(res) ? res : [res]).map((rfq: any) => ({
            ...rfq,
            warehouse: rfq.warehouse
              ? rfq.warehouse
              : {
                warehouseName: rfq.warehouseName || '',
                warehouseCode: rfq.warehouseCode || '',
                warehouseId: rfq.warehouseId || ''
              }
          }));
          this.rfqList = [...this.rfqList];
        },
        error: (err) => {
          console.error('Search error:', err);
          this.rfqList = [];
        }
      });
    } else {
      this.getRFQList();
    }
  }

  refreshData(): void {
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getRFQList();
    this.selectedRfq = [];
  }



  // loadRfqList(event: any) {
  //   this.pageRequest.pageIndex = event.first / event.rows;
  //   this.pageRequest.pageSize = event.rows;

  //   if (this.searchKey && this.searchKey.trim() !== '') {
  //     this.searchRfq();
  //   } else {
  //     this.getRFQList();
  //   }
  // }

  loadRfqList(event: any) {
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchRfq();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getRFQList();
    }
  }


  getRFQList() {
    this.rfqService.getRFQList(this.pageRequest).subscribe(
      (data: any) => {
        if (data && data.rfQs) {
          this.rfqList = data.rfQs;
        } else {
          this.rfqList = [];
        }
      },
      (error: any) => {
        console.error("Failed to fetch RFQs", error);
        this.rfqList = [];
      }
    );

  }

  showReport(data: any) {

  }


  placeholder: string = 'Search By ';
  private messages: string[] = ['RFQ No', 'RFQ Name', 'RFQ Date', 'Unit Name', 'Created By'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }


}
